import styled from 'styled-components';

export const CellContent = styled.div`
  margin: 1px 0 15px;
  padding: 8px 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  border-radius: 10px;
  background: var(--color-error-surface);
  color: var(--color-error-heading);
  font-weight: 500;
  font-size: 12px;
  line-height: 160%;
  white-space: normal !important;

  svg {
    flex: 0 0 auto;
  }
`;
